<h2>セクション情報</h2>
<div class="column-list">
  <div class="list-input-title">セクション名</div>
  <div class="list-input-content">
    <input type="text" style="width:20rem;" id="lbl_SectionName" readonly
      value="{{selectedSectionInfo.sectionTemplateName}}" />
  </div>
  <!-- <div class="list-input-content" id="lbl_SectionName">{{selectedSectionInfo.sectionTemplateName}}</div> -->
  <div class="list-input-title">基点X(mm)</div>
  <div class="list-input-content">
    <input type="text" style="width:8rem;" id="lbl_SectionPosX" readonly
      value="{{selectedSectionInfo.positionX}}" />
  </div>
  <!-- <div class="list-input-content" id="lbl_SectionPosX">{{selectedSectionInfo.positionX}}</div> -->
  <div class="list-input-title">基点Y(mm)</div>
  <div class="list-input-content">
    <input type="text" style="width:8rem;" id="lbl_SectionPosY" readonly
      value="{{selectedSectionInfo.positionY}}" />
  </div>
  <!-- <div class="list-input-content" id="lbl_SectionPosY">{{selectedSectionInfo.positionY}}</div> -->
  <div class="list-input-title">セクション領域幅(mm)</div>
  <div class="list-input-content">
    <input type="text" style="width:8rem;" id="lbl_SectionWidth" readonly
      value="{{selectedSectionInfo.width}}" />
  </div>
  <!-- <div class="list-input-content" id="lbl_SectionWidth">{{selectedSectionInfo.width}}</div> -->
  <div class="list-input-title">セクション領域高さ(mm)</div>
  <div class="list-input-content">
    <input type="text" style="width:8rem;" id="lbl_SectionHeight" readonly
      value="{{selectedSectionInfo.height}}" />
  </div>
  <!-- <div class="list-input-content" id="lbl_SectionHeight">{{selectedSectionInfo.height}}</div> -->
  <div class="list-input-title">グリッド</div>
  <div class="list-input-content block-row">
    <span>横</span>
    <div class="list-input-content">
      <input type="text" style="width:6rem;" id="lbl_SectionDivW" readonly
        value="{{selectedSectionInfo.divW}}" />
    </div>
    <!-- <span id="lbl_SectionDivW">{{selectedSectionInfo.divW}}</span> -->
    <span>×</span>
    <span>縦</span>
    <div class="list-input-content">
      <input type="text" style="width:6rem;" id="lbl_SectionDivH" readonly
        value="{{selectedSectionInfo.divH}}" />
    </div>
    <!-- <span id="lbl_SectionDivH">{{selectedSectionInfo.divH}}</span> -->
  </div>
</div>
